import AbstractComponent from './AbstractComponent';
import RAF from 'core/RAF';
import ScrollManager from '../managers/ScrollManager';
import ResizeManager from '../managers/ResizeManager';
import { clamp } from 'gsap/gsap-core';
import { clampLoop } from 'helpers/clampLoop';

class PushMultiProduct extends AbstractComponent {
  constructor() {
    super(...arguments);
    console.log({element: this.ui.$element});
  }

  bind() {
    super.bind();
    this.handleRaf = this.handleRaf.bind(this);
    this.onDotClick = this.onDotClick.bind(this);
    this.onZoneClick = this.onZoneClick.bind(this);
    this.getTimer = this.getTimer.bind(this);
    this.handleTouch = this.handleTouch.bind(this);
    this.handleMouseLink = this.handleMouseLink.bind(this);
  }

  initializeBeforeEvents() {
    this.smoothScrollTop = 0;
    this.active = 0;

    this.ui.$element.dataset.length = this.ui.$items.length;
    this.ui.$wrapper.style.width = `${this.ui.$items.length * 100}%`;
    this.ui.$items.forEach(($item) => $item.style.width = `${100 / this.ui.$items.length}%`);
  }

  getUI() {
    const ui = super.getUI();
    ui.$wrapper = ui.$element.querySelector('.push-multi-product__wrapper');
    ui.$items = [...ui.$element.querySelectorAll('.push-multi-product__item')];
    ui.$images = [...ui.$element.querySelectorAll('.push-multi-product__image')];
    ui.$dots = [...ui.$element.querySelectorAll('.push-multi-product__dots button')];
    ui.$zones = [...ui.$element.querySelectorAll('.push-multi-product__zones div')];
    ui.$links = [...ui.$element.querySelectorAll('a')];
    return ui;
  }

  initialize() {
    super.initialize();
    RAF.suscribe('pushMultiProduct', this.handleRaf);

    this.interval = this.getTimer();
  }

  getTimer() {
    return setInterval(() => {
      this.active = clampLoop(this.active + 1, 0, this.ui.$items.length - 1);
    }, 10000);
  }

  events(listen) {
    super.events(listen);
    const method = listen ? 'addEventListener' : 'removeEventListener';

    this.ui.$element[method]('touchstart', this.handleTouch);
    this.ui.$element[method]('touchend', this.handleTouch);

    this.ui.$dots.forEach(($dot) => $dot[method]('click', this.onDotClick));
    this.ui.$zones.forEach(($zone) => $zone[method]('click', this.onZoneClick));
    this.ui.$links.forEach(($link) => {
      $link[method]('mouseenter', this.handleMouseLink);
      $link[method]('mouseleave', this.handleMouseLink);
    });
  }

  handleTouch(event) {
    if (event.type === 'touchstart') {
      clearTimeout(this.interval);
      this.touchStart = event.touches[0].clientX;
    } else {
      this.interval = this.getTimer();

      const diff = this.touchStart - event.changedTouches[0].clientX;
      if (diff > 50) {
        this.active = clamp(0, this.ui.$items.length - 1, this.active + 1)
      } else if (diff < -50) {
        this.active = clamp(0, this.ui.$items.length - 1, this.active - 1)
      }
    }
  }

  handleMouseLink(event) {
    if (event.type === 'mouseenter') {
      clearInterval(this.interval);
    } else {
      this.interval = this.getTimer();
    }
  }

  handleRaf() {
    const sT = ScrollManager.scrollTop;
    this.smoothScrollTop += (sT - this.smoothScrollTop) * 0.15;

    const progress = clamp(0, 1, this.smoothScrollTop / ResizeManager.height);
    for (var i = 0, l = this.ui.$images.length; i < l; i++) {
      this.ui.$images[i].style.transform = `translateY(${progress * 25}%)`;
    }
  }

  onDotClick(event) {
    this.active = this.ui.$dots.indexOf(event.currentTarget);
  }

  onZoneClick(event) {
    const index = this.ui.$zones.indexOf(event.currentTarget);
    const direction = index === 0 ? -1 : 1;
    this.active = clamp(0, this.ui.$items.length - 1, this.active + direction);
  }

  get active() {
    return this._active;
  }

  set active(value) {
    this._active = value;

    this.ui.$items.forEach(($item, index) => {
      $item.classList.toggle('is-active', index === value);
      $item.style.transform = `translateX(-${value * 100}%)`;
    });

    this.ui.$dots.forEach(($dot, index) => {
      $dot.classList.toggle('is-active', index === value);
    })

    this.ui.$zones[0].classList.toggle('is-active', value > 0);
    this.ui.$zones[1].classList.toggle('is-active', value < this.ui.$items.length - 1);
  }
}

export default PushMultiProduct;
